module.exports = __webpack_public_path__ + "static/media/medrt.f3347612.svg";